module.exports = __webpack_public_path__ + "static/PubliBike_Logo_horizontal_RGB-ce7bb822ae3302ab79b7afe148320083.jpg";